<div class="main-panel container-fluid">
  <div class="row actions">
    <div class="col-md-2">
      <button class="btn btn-primary-outline" (click)="showFilters()">
        <div class="icon-filter">
          <i class="fa fa-sliders"></i>
          <i *ngIf="filtroActivo" class="fa fa-warning warning-icon" color="warn"></i>
        </div>
      </button>

    </div>

  </div>
  <form *ngIf="filters" class="form-inline form-header row" novalidate [formGroup]="filterForm" (ngSubmit)="onSearch()">
    <div class="row">
      <div class="col-md-3 ">
        <div class="form-group">
          <label for="insumo">Insumo</label>
          <ng-multiselect-dropdown id="insumo" [placeholder]="'Seleccione'" formControlName="insumo"
            [settings]="dropdownSettingsInsumo" [data]="insumos" (onSelect)="onSearch()"
            (onDeSelect)="onDeSelectInsumo($event)" class="filter-insumo">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-md-3 ">
        <div class="form-group">
          <label for="cultivo">Cultivo</label>
          <ng-multiselect-dropdown id="cultivo" [placeholder]="'Todos'" formControlName="cultivo"
            [settings]="baseDropdownSettings" [data]="cultivos" (onSelect)="onSelectCultivo()"
            (onDeSelect)="onSelectCultivo()" (onSelectAll)="onSelectCultivo()" (onDeSelectAll)="onSelectCultivo()"
            class="filter-insumo">
          </ng-multiselect-dropdown>
        </div>
      </div>

      <div class="col-md-3" *ngIf="rolUser === 'CORPORATE' ">
        <div class="form-group">
          <label for="empresa">Empresa</label>
          <ng-multiselect-dropdown id="empresa" [placeholder]="'Todos'" formControlName="empresa"
            [settings]="baseDropdownSettings" (onSelect)="onSelectEmpresa()" (onDeSelect)="onDeSelectEmpresa()"
            (onSelectAll)="onSelectEmpresa()" (onDeSelectAll)="onDeSelectEmpresa()" [data]="empresas">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-md-3 "
        *ngIf="(rolUser === 'COMPANY' || rolUser ==='CORPORATE') && usuariosZona && usuariosZona.length">
        <div class="form-group">
          <label for="distribuidor">Zonal</label>
          <ng-multiselect-dropdown id="usuarioZona" [placeholder]="'Todos'" formControlName="usuarioZona"
            [settings]="baseDropdownSettings" (onSelect)="onSelectUsuarioZona()" (onDeSelect)="onDeSelectUsuarioZona()"
            (onSelectAll)="onSelectUsuarioZona()" (onDeSelectAll)="onDeSelectUsuarioZona()" [data]="usuariosZona">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-md-3  " *ngIf="rolUser === 'ZONA' || rolUser === 'COMPANY' || rolUser ==='CORPORATE' ">
        <div class="form-group">
          <label for="distribuidor">Distribuidor</label>
          <ng-multiselect-dropdown id="distribuidor" [placeholder]="'Todos'" formControlName="distribuidor"
            [settings]="baseDropdownSettings" (onSelect)="onSelectDistribuidor()"
            (onDeSelect)="onDeSelectDistribuidor()" (onSelectAll)="onSelectDistribuidor()"
            (onDeSelectAll)="onDeSelectDistribuidor()" [data]="distribuidores">
          </ng-multiselect-dropdown>
        </div>


      </div>
      <div class="col-md-3  "
        *ngIf="rolUser === 'ZONA' || rolUser === 'COMPANY' || rolUser === 'DISTRIBUTOR' || rolUser ==='CORPORATE' ">
        <div class="form-group">
          <label for="productor">Productor</label>
          <ng-multiselect-dropdown id="productor" [placeholder]="'Todos'" formControlName="productor"
            [settings]="baseDropdownSettings" [data]="productores" (onSelect)="onSelectProductor()"
            (onDeSelect)="onSelectProductor()" (onSelectAll)="onSelectProductor()"
            (onDeSelectAll)="onSelectProductor()">
          </ng-multiselect-dropdown>
        </div>


      </div>
    </div>
    <div class="row margin-top">
      <div class="col-md-3">
        <button type="button" class="btn btn-primary-outline btn-block" (click)="reset()"
          [disabled]="!filterForm.valid">Limpiar
        </button>
      </div>
    </div>


  </form>
  <div class="row">
    <div class="col-md-3 col-xs-12 margin-top">
      <div class="nf-card hectares-summary-card">
        <div class="card-loading" *ngIf="loadingHectareasProvincia">Cargando...</div>
        <div class="hectares-summary-label">Hectáreas aseguradas</div>
        <div class="hectares-summary-main">
          <div class="hectares-summary-icon">
            <i class="fa fa-leaf"></i>
          </div>
          <div class="hectares-summary-content">
            <div class="hectares-summary-value">{{ hectareasCampaniaActual | number:'1.0-0' }}</div>
            <div class="hectares-summary-unit">Hectáreas</div>
          </div>
        </div>
        <div class="hectares-summary-comparison" *ngIf="diferenciaHectareasPorcentaje !== null"
          [class.is-negative]="diferenciaHectareasPorcentaje < 0">
          <span>{{ diferenciaHectareasPorcentaje >= 0 ? '↑' : '↓' }}</span>
          {{ diferenciaHectareasPorcentaje | number:'1.1-1' }}%
          <small>vs {{ campaniaAnteriorLabel }}</small>
        </div>
        <div class="hectares-summary-comparison is-unavailable" *ngIf="diferenciaHectareasPorcentaje === null">
          Sin comparación disponible
        </div>
      </div>
    </div>
    <div class="col-md-3 col-xs-12 margin-top">
      <div class="nf-card hectares-summary-card insumo-summary-card">
        <div class="card-loading" *ngIf="loadingInsumoIncluido">Cargando...</div>
        <div class="hectares-summary-label">Insumo incluido</div>
        <div class="hectares-summary-main">
          <div class="hectares-summary-icon">
            <i class="fa fa-shopping-bag"></i>
          </div>
          <div class="hectares-summary-content">
            <div class="hectares-summary-value">{{ insumoIncluidoCampaniaActual | number:'1.0-0' }}</div>
            <div class="hectares-summary-unit">{{ filtro?.insumo }}</div>
          </div>
        </div>
        <div class="hectares-summary-comparison" *ngIf="diferenciaInsumoIncluidoPorcentaje !== null"
          [class.is-negative]="diferenciaInsumoIncluidoPorcentaje < 0">
          <span>{{ diferenciaInsumoIncluidoPorcentaje >= 0 ? '↑' : '↓' }}</span>
          {{ diferenciaInsumoIncluidoPorcentaje | number:'1.1-1' }}%
          <small>vs {{ insumoIncluidoAnteriorLabel }}</small>
        </div>
        <div class="hectares-summary-comparison is-unavailable" *ngIf="diferenciaInsumoIncluidoPorcentaje === null">
          Sin comparación disponible
        </div>
      </div>
    </div>
    <div class="col-md-3 col-xs-12 margin-top">
      <div class="nf-card hectares-summary-card productores-summary-card">
        <div class="card-loading" *ngIf="loadingProductores">Cargando...</div>
        <div class="hectares-summary-label">Productores activos</div>
        <div class="hectares-summary-main">
          <div class="hectares-summary-icon">
            <i class="fa fa-users"></i>
          </div>
          <div class="hectares-summary-content">
            <div class="hectares-summary-value">{{ productoresActivos | number:'1.0-0' }}</div>
            <div class="hectares-summary-unit">Productores</div>
          </div>
        </div>
        <div class="hectares-summary-comparison" *ngIf="diferenciaProductoresActivosPorcentaje !== null"
          [class.is-negative]="diferenciaProductoresActivosPorcentaje < 0">
          <span>{{ diferenciaProductoresActivosPorcentaje >= 0 ? '↑' : '↓' }}</span>
          {{ diferenciaProductoresActivosPorcentaje | number:'1.1-1' }}%
          <small>vs {{ productoresActivosAnteriorLabel }}</small>
        </div>
        <div class="hectares-summary-comparison is-unavailable" *ngIf="diferenciaProductoresActivosPorcentaje === null">
          Sin comparación disponible
        </div>
      </div>
    </div>
    <div class="col-md-3 col-xs-12 margin-top">
      <div class="nf-card hectares-summary-card siniestros-summary-card">
        <div class="card-loading" *ngIf="loadingHectareasAfectadas">Cargando...</div>
        <div class="hectares-summary-label">Siniestros</div>
        <div class="hectares-summary-main">
          <div class="hectares-summary-icon">
            <i class="fa fa-exclamation-triangle"></i>
          </div>
          <div class="hectares-summary-content">
            <div class="hectares-summary-value">{{ hectareasAfectadasCampaniaActual | number:'1.0-0' }}</div>
            <div class="hectares-summary-unit">Hectáreas afectadas</div>
          </div>
        </div>
        <div class="hectares-summary-comparison" *ngIf="porcentajeHectareasAfectadasSobreAseguradas !== null">
          {{ porcentajeHectareasAfectadasSobreAseguradas | number:'1.1-1' }}%
          <small>vs hectáreas aseguradas</small>
        </div>
        <div class="hectares-summary-comparison is-unavailable"
          *ngIf="porcentajeHectareasAfectadasSobreAseguradas === null">
          Sin comparación disponible
        </div>
      </div>
    </div>
  </div>
  <div class="row row-equal">
    <div class="col-md-6 margin-top">
      <div class="nf-card">
        <div class="card-loading" *ngIf="loadingHectareasProvincia">Cargando...</div>
        <div class="card-header">
          <h2 class="card-title card-title-siniestro">Hectáreas Aseguradas por Provincia</h2>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <div class="provincia-table" *ngIf="hectareasPorProvincia.length">
                <div class="provincia-table-row provincia-table-header">
                  <span>Provincia</span>
                  <span>Has.</span>
                  <span>%</span>
                </div>
                <div class="provincia-table-row" *ngFor="let item of hectareasPorProvincia">
                  <span>{{ item.provincia }}</span>
                  <span>{{ item.hectareas | number:'1.0-0' }}</span>
                  <span>{{ item.porcentaje | number:'1.0-2' }} %</span>
                </div>
                <div class="provincia-table-row provincia-table-total">
                  <span>Total</span>
                  <span>{{ totalHectareasPorProvincia | number:'1.0-0' }}</span>
                  <span>100 %</span>
                </div>
              </div>
              <p *ngIf="!hectareasPorProvincia.length">No hay hectáreas aseguradas para la campaña actual.</p>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="map-container">
                <p *ngIf="!mapaProvinciasListo">Cargando mapa...</p>
                <div *ngIf="mapaProvinciasListo" echarts [options]="chartHectareasProvinciaOptions" class="echart-map">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 margin-top">
      <div class="nf-card">
        <div class="card-loading" *ngIf="loadingDenunciasProvincia">Cargando...</div>
        <div class="card-header">
          <h2 class="card-title card-title-siniestro">Denuncias de Siniestros por Provincia</h2>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <div class="denuncias-table" *ngIf="denunciasPorProvincia.length">
                <div class="denuncias-table-row denuncias-table-header">
                  <span>Provincia</span>
                  <span>Denuncias</span>
                </div>
                <div class="denuncias-table-row" *ngFor="let item of denunciasPorProvincia">
                  <span>{{ item.provincia }}</span>
                  <span>{{ item.cantidad | number:'1.0-0' }}</span>
                </div>
                <div class="denuncias-table-row denuncias-table-total">
                  <span>Total</span>
                  <span>{{ totalDenunciasPorProvincia | number:'1.0-0' }}</span>
                </div>
              </div>
              <p *ngIf="!denunciasPorProvincia.length">No hay denuncias para la campaña actual.</p>
            </div>
            <div class="col-md-6 col-xs-12">
              <div class="map-container">
                <div *ngIf="mapaProvinciasListo" echarts [options]="mapaDenunciasProvinciasOptions" class="echart-map">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-md-6 col-xs-12 margin-top">
      <div class="nf-card">
        <div class="card-loading" *ngIf="loadingInsumos">Cargando...</div>
        <canvas id="chartInsumos" baseChart [datasets]="chartInsumosData" [labels]="chartInsumosLabels"
          [options]="chartInsumosOptions" [legend]="chartInsumosLegend" [chartType]="$any(chartInsumosType)"
          label="Insumos">
        </canvas>
      </div>
    </div>
    <div class="col-md-6 col-xs-12 margin-top">
      <div class="nf-card">
        <div class="card-loading" *ngIf="loadingHectareas">Cargando...</div>
        <canvas baseChart [datasets]="chartHectareasData" [labels]="chartHectareasLabels"
          [options]="chartHectareasOptions" [legend]="chartHectareasLegend" [chartType]="$any(chartHectareasType)">
        </canvas>
      </div>
    </div>
  </div> -->

  <div class="row">

  </div>
  <div class="row">


    <div class="col-md-6 col-xs-12 margin-top" *ngIf="mostrarEstadosPlanes">
      <div class="nf-card">
        <div class="card-loading" *ngIf="loadingEstadosPlanes">Cargando...</div>
        <div class="card-header">
          <h3 class="card-title card-title-siniestro">Estado de Planes de Siembra</h3>
        </div>
        <div class="card-body">
          <div class="pie-chart-container" *ngIf="estadosPlanesResumen.length">
            <canvas baseChart
              [datasets]="[{ data: chartTortaData, backgroundColor: ['#43a047', '#1e88e5', '#fb8c00', '#8e5ac8', '#ef5350', '#00acc1', '#6d4c41', '#7cb342'] }]"
              [labels]="chartTortaLabels" [options]="chartEstadosPlanesOptions" [legend]="true"
              [chartType]="'doughnut'"></canvas>
          </div>
          <div class="estado-total" *ngIf="estadosPlanesResumen.length">
            <strong>Total</strong>
            <strong>{{ totalEstadosPlanes | number:'1.0-0' }} (100%)</strong>
          </div>
          <p *ngIf="!loadingEstadosPlanes && !estadosPlanesResumen.length">No hay planes de siembra para la campaña
            actual.</p>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-xs-12 margin-top" *ngIf="mostrarEstadosSolicitudes">
      <div class="nf-card">
        <div class="card-loading" *ngIf="loadingEstadosSolicitudes">Cargando...</div>
        <div class="card-header">
          <h3 class="card-title card-title-siniestro">Estado de Solicitudes</h3>
        </div>
        <div class="card-body">
          <div class="pie-chart-container" *ngIf="estadosSolicitudesResumen.length">
            <canvas baseChart
              [datasets]="[{ data: chartSolicitudesData, backgroundColor: ['#43a047', '#1e88e5', '#fb8c00', '#8e5ac8', '#ef5350', '#00acc1', '#6d4c41', '#7cb342'] }]"
              [labels]="chartSolicitudesLabels" [options]="chartEstadosSolicitudesOptions" [legend]="true"
              [chartType]="'doughnut'"></canvas>
          </div>
          <div class="estado-total" *ngIf="estadosSolicitudesResumen.length">
            <strong>Total</strong>
            <strong>{{ totalEstadosSolicitudes | number:'1.0-0' }} (100%)</strong>
          </div>
          <p *ngIf="!loadingEstadosSolicitudes && !estadosSolicitudesResumen.length">No hay solicitudes para los filtros
            seleccionados.</p>
        </div>
      </div>
    </div>
   



  </div>
  <div class="row row-equal">
     <div class="col-md-6 col-xs-12 margin-top">
      <div class="nf-card ">
        <div class="card-loading" *ngIf="loadingHectareasAfectadasPorEstado">Cargando...</div>
        <div class="card-header">
          <h3 class="card-title card-title-siniestro">Estados de Siniestros</h3>
        </div>
        <div class="card-body">
          <div class="pie-chart-container" *ngIf="hectareasAfectadasPorEstado.length">
            <canvas baseChart [datasets]="chartSiniestrosEstadoData" [labels]="chartSiniestrosEstadoLabels"
              [options]="chartSiniestrosEstadoOptions" [legend]="true" [chartType]="'doughnut'"></canvas>
          </div>
          <div class="estado-total" *ngIf="hectareasAfectadasPorEstado.length">
            <strong>Total</strong>
            <strong>{{ totalHectareasAfectadasPorEstado | number:'1.0-0' }} ha (100%)</strong>
          </div>
          <p *ngIf="!loadingHectareasAfectadasPorEstado && !hectareasAfectadasPorEstado.length">
            No hay hectáreas afectadas para la campaña actual.
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-xs-12 margin-top">
      <div class="nf-card">
        <div class="card-header">
          <h2 class="card-title card-title-siniestro">Siniestros por Tipo de Evento</h2>
        </div>
        <div class="card-body">
          <div class="card-loading" *ngIf="loadingHectareasAfectadasPorEvento">Cargando...</div>
          <div class="evento-table" *ngIf="hectareasAfectadasPorEvento.length">
            <div class="evento-table-row evento-table-header">
              <span>Tipo de evento</span>
              <span>Hectáreas afectadas</span>
              <span>% del total</span>
            </div>
            <div class="evento-table-row" *ngFor="let item of hectareasAfectadasPorEvento">
              <strong class="evento-name">{{ item.evento }}</strong>
              <span class="evento-bar-cell">
                <span class="evento-bar"
                  [style.width.%]="item.hectareas * 100 / (hectareasAfectadasPorEvento[0].hectareas || 1)"
                  [style.background-color]="item.color"></span>
                <strong>{{ item.hectareas | number:'1.0-0' }}</strong>
              </span>
              <span>{{ item.porcentaje | number:'1.1-1' }}%</span>
            </div>
            <div class="evento-table-row evento-table-total">
              <span>Total</span>
              <span>{{ totalHectareasAfectadasPorEvento | number:'1.0-0' }}</span>
              <span>100%</span>
            </div>
          </div>
          <p *ngIf="!loadingHectareasAfectadasPorEvento && !hectareasAfectadasPorEvento.length">
            No hay hectáreas afectadas para la campaña actual.
          </p>
        </div>
      </div>
    </div>





  </div>

  <div class="row" *ngIf="rolUser === 'CORPORATE'">
    <div class="col-md-12 margin-top">
      <div class="nf-card">
        <div class="card-header">
          <h2 class="card-title card-title-siniestro">Promedios históricos por insumo y cultivo</h2>
        </div>
        <div class="card-body">
          <p *ngIf="loadingPromediosHistoricos">Cargando promedios...</p>
          <div class="promedios-table" *ngIf="!loadingPromediosHistoricos && promediosHistoricos.length">
            <div class="promedios-table-row promedios-table-header">
              <span>Insumo</span>
              <span>Cultivo</span>
              <span class="text-right">Promedio por hectárea</span>
            </div>
            <div class="promedios-table-row" *ngFor="let promedio of promediosHistoricos">
              <span>{{ promedio.insumo }}</span>
              <span>{{ promedio.tipoCultivo }}</span>
              <span class="text-right">{{ promedio.promedio | number:'1.0-2' }}</span>
            </div>
          </div>
          <p *ngIf="!loadingPromediosHistoricos && !promediosHistoricos.length">
            No hay promedios guardados para la campaña seleccionada.
          </p>
        </div>
      </div>
    </div>
  </div>



</div>